import { makeAutoObservable } from "mobx";
import RootStore from "stores/RootStore";
// import GenerateData from 'shared/generators/GenerateData'; // Adjust the path as necessary
import { utils, getDateRange } from "@intrasync/utils";
import ServiceStore from "stores/ServiceStore";
import ProductionScheduleRightHeaderCell from "./ProductionOverviewScheduleCells/ProductionOverviewSchedule.RightHeaderCell";
import ProductionScheduleRightBodyCell from "./ProductionOverviewScheduleCells/ProductionOverviewSchedule.RightBodyCell";
import ProductionScheduleLeftHeaderCell from "./ProductionOverviewScheduleCells/ProductionOverviewSchedule.LeftHeaderCell";
import ProductionScheduleLeftBodyCell from "./ProductionOverviewScheduleCells/ProductionOverviewSchedule.LeftBodyCell";

class ProductionOverviewSheduleStore {
  hiddenColumns: number[] = [];
  rootStore: RootStore;

  constructor(rootStore: RootStore) {
    makeAutoObservable(this);
    this.rootStore = rootStore;
  }

  setHiddenColumn = (columnIndex: number) => {
    if (this.hiddenColumns.includes(columnIndex)) {
      this.hiddenColumns = this.hiddenColumns.filter(
        (column) => column !== columnIndex
      );
      return;
    }
    this.hiddenColumns.push(columnIndex);
  };

  get jobNumbersWithinDateInRange() {
    const routerStore = this.rootStore.routerStore;
    if (!routerStore?.queryParams) return [];
    const { startDate, endDate } = routerStore.queryParams as {
      startDate: string;
      endDate: string;
    };
    // console.log('startDate', startDate);
    // console.log('endDate', endDate);

    const filteredJobNumbers = this.allEntities
      .filter(
        (entity) =>
          entity.castingDate &&
          entity.jobNumber &&
          entity.castingDate >= startDate &&
          entity.castingDate <= endDate
      )
      .map((entity) => entity.jobNumber as number);

    const currentEntitiesJobNumbers = utils.uniqueArray(
      filteredJobNumbers
    ) as number[];
    return currentEntitiesJobNumbers.sort((a, b) => a - b);
  }

  get columnHeaders() {
    // console.log(
    //   'Getting column headers this.currentEntitiesMolds',
    //   this.currentEntitiesMolds
    // );
    const headersByJobNumber = this.jobNumbersWithinDateInRange
      .filter((jobNumber) => {
        return this.jobNumbersWithinDateInRange.includes(jobNumber as number);
      })
      .filter((jobNumber) => {
        return !this.hiddenColumns.includes(jobNumber);
      })
      .map((jobNumber) => {
        return {
          width: 200,
          title: jobNumber.toString(),
          key: jobNumber,
          headerKey: "jobNumber",
          component: ProductionScheduleRightHeaderCell,
          bodyComponent: ProductionScheduleRightBodyCell,
        };
      });

    return [
      {
        width: 200,
        title: "Date",
        key: "castingDate",
        component: ProductionScheduleLeftHeaderCell,
        bodyComponent: ProductionScheduleLeftBodyCell,
      },
      ...headersByJobNumber,
    ];
  }

  get allEntities() {
    const panelStore = this.rootStore.panelStore as ServiceStore;
    return panelStore.entities;
  }

  get entities() {
    if (!this.allEntities) return [];
    const currentEntities = this.allEntities.filter((entity) => {
      if (entity.castingDate === "1970-01-01") return false;

      return this.jobNumbersWithinDateInRange.includes(
        entity.jobNumber as number
      );
    });
    // console.log('ProductionScheduleStore entities', currentEntities);
    return currentEntities;
  }

  get dateRange() {
    const routerStore = this.rootStore.routerStore;
    if (!routerStore?.queryParams) return [];
    const { startDate, endDate } = routerStore.queryParams as {
      startDate: string;
      endDate: string;
    };

    // console.log('ProductionScheduleStore dateRange dates', dates);

    return getDateRange(startDate, endDate, { weekdays: true });
  }
}

export default ProductionOverviewSheduleStore;
